import { useEffect, useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import { useSettings } from "@/context/SettingsContext";
import api from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export default function Layout() {
  const [pending, setPending] = useState(0);
  const { settings } = useSettings();

  const loadPending = useCallback(async () => {
    try {
      const { data } = await api.get("/queue", { params: { status: "pending" } });
      setPending(data.length);
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    loadPending();
    const t = setInterval(loadPending, 15000);
    const h = () => loadPending();
    window.addEventListener("queue-changed", h);
    return () => { clearInterval(t); window.removeEventListener("queue-changed", h); };
  }, [loadPending]);

  return (
    <div className="min-h-screen bg-[#090B0E]">
      <Sidebar pendingCount={pending} />
      <TopBar pendingCount={pending} />
      <main className="pl-64 pt-16 min-h-screen">
        {settings?.kill_switch && (
          <div data-testid="kill-switch-banner" className="ml-0 mx-8 mt-4 flex items-center gap-2 px-4 py-2.5 rounded-lg bg-red-600/15 border border-red-500/40 text-red-300 text-sm font-medium">
            <AlertTriangle className="w-4 h-4" />
            Kill switch active — all autonomous agents are paused. Approvals and publishing are blocked until you resume.
          </div>
        )}
        <div className="p-8 space-y-8 fade-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
